import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = { class: "nav-item" }

import IbRecord from "@/projects/tenant/modules/rebate/components/IbRecord.vue";
import IbRebateReport from "@/projects/tenant/modules/rebate/components/IbRebateReport.vue";
import { ref, provide } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'RebateRecord',
  setup(__props) {

const tab = ref("record");
const isLoading = ref(false);
provide("isLoading", isLoading);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === 'record' },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tab.value = 'record'))
        }, _toDisplayString(_ctx.$t("title.record")), 3)
      ]),
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("a", {
          class: _normalizeClass(["nav-link text-active-primary pb-4", [
            { active: tab.value === 'report' },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]]),
          "data-bs-toggle": "tab",
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'report'))
        }, _toDisplayString(_ctx.$t("title.report")), 3)
      ])
    ]),
    (tab.value === 'record')
      ? (_openBlock(), _createBlock(IbRecord, { key: 0 }))
      : _createCommentVNode("", true),
    (tab.value === 'report')
      ? (_openBlock(), _createBlock(IbRebateReport, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})